import { Wizard } from '@/components/wizard/Wizard';
import { useWorkspace } from '@/contexts/useWorkspace';

import type { MongoAtlasConnectOrganizationState } from './connectMongoAtlasSourceOrganization';
import type { MongoAtlasConnectProjectState } from './connectMongoAtlasSourceProject';
import {
  mongoAtlasConnectSourceOrganizationFlow,
  mongoAtlasConnectSourceProjectFlow,
} from './mongoAtlasConnectFlows';

export function MongoAtlasConnectSourceWizard({
  onCreated,
  selectedScope,
}: {
  onCreated: () => Promise<void>;
  selectedScope: 'organization' | 'project';
}) {
  const { rightPanel } = useWorkspace();

  const onFinish = async () => {
    await onCreated();
    return true;
  };

  if (selectedScope === 'organization') {
    return (
      <Wizard<MongoAtlasConnectOrganizationState>
        hideCloseButton={false}
        onAbort={() => rightPanel.setIsOpen(false)}
        hideBackArrow={true}
        onFinish={onFinish}
        flow={[mongoAtlasConnectSourceOrganizationFlow]}
        title='Connect source organization'
        initialState={{
          connectMethod: 'terraform',
          apiPublicKey: '',
          apiPrivateKey: '',
        }}
      />
    );
  }

  return (
    <Wizard<MongoAtlasConnectProjectState>
      hideCloseButton={false}
      onAbort={() => rightPanel.setIsOpen(false)}
      hideBackArrow={true}
      onFinish={onFinish}
      flow={[mongoAtlasConnectSourceProjectFlow]}
      title='Connect source project'
      initialState={{
        connectMethod: 'terraform',
        projectId: '',
        apiPublicKey: '',
        apiPrivateKey: '',
      }}
    />
  );
}
